import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { aboutContent } from '../data/mockData';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-16">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row gap-12">
          {/* Content */}
          <motion.div 
            className="w-full lg:w-2/3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl md:text-4xl font-bold text-sharon-dark-green mb-6">
              אודות
            </h1>
            
            <div className="space-y-4 mb-8">
              {aboutContent.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-lg text-sharon-gray">
                  {paragraph}
                </p>
              ))}
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-semibold text-sharon-dark-green mb-4">
                השכלה והכשרה
              </h2>
              <ul className="list-disc list-inside space-y-2 text-sharon-gray">
                {aboutContent.education.map((item, index) => (
                  <li key={index} className="text-lg">
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-semibold text-sharon-dark-green mb-4">
                הגישה הטיפולית שלי
              </h2>
              <div className="space-y-2 text-sharon-gray">
                {aboutContent.approach.map((item, index) => (
                  <p key={index} className="text-lg">
                    {item}
                  </p>
                ))}
              </div>
            </div>

            <div className="mt-10">
              <h2 className="text-2xl font-semibold text-sharon-dark-green mb-4">
                צרו קשר
              </h2>
              <p className="text-lg text-sharon-gray mb-4">
                לקביעת פגישת היכרות או לכל שאלה, אנא צרו איתי קשר:
              </p>
              <div className="space-y-2">
                <p className="text-lg">טלפון: <a href="tel:+972526507776" className="text-sharon-dark-green hover:text-sharon-green">0526507776</a></p>
                <p className="text-lg">מייל: <a href="mailto:sharon.weisfeld@gmail.com" className="text-sharon-dark-green hover:text-sharon-green">sharon.weisfeld@gmail.com</a></p>
                <p className="text-lg">מיקום: הוד השרון והסביבה</p>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div 
            className="w-full lg:w-1/3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="sticky top-32">
              <div className="rounded-lg overflow-hidden shadow-lg">
                <img 
                  src={aboutContent.image} 
                  alt="שרון וייספלד" 
                  className="w-full h-auto"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;